import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children }) => {
  return (
    <div className="page-container">
      <Header />
      <main className="main-content pt-20">
        {children}
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
};

export const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {children}
      <Toaster position="top-right" richColors />
    </div>
  );
};
